import React from 'react'

const ServeYouth = () => {
	return (
		<div className='converseValues-content'>
			<h1 className='section-title'>Serve Youth*</h1>

			<div className='ncss-row' style={{ marginTop: '48px', borderBottom: '1px solid white', paddingBottom: '50px' }}>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						Obsess
					</p>
					<p className='section-p'>
						We don’t just show up – we’re all in. Creating a deep understanding for how youth seek to express themselves is
						how we deliver relevant solutions.
					</p>
				</div>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						champion
					</p>
					<p className='section-p'>
						We recognize the power of youth to point the way forward. Their passion fuels our passion. Our work amplifying
						and enabling the voice of youth is never finished.
					</p>
				</div>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						inspire
					</p>
					<p className='section-p'>
						We believe in the limitless potential of youth. Our potential lies in taking them to the places they want to go
						and the places they didn’t know they could go. 2
					</p>
				</div>
			</div>
			<div className='converse-behaviros'>
				<p className='section-title' style={{ marginTop: '50px', marginBottom: '24px', fontSize: '40px' }}>
					Behaviors
				</p>

				<div className='ncss-row' style={{ marginTop: '24px' }}>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I ACT IN SERVICE OF THE YOUTH (AGE AND MINDSET)
						</p>
					</div>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I CONNECT TO YOUTH CULTURE EVERY DAY
						</p>
					</div>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I SEEK TO ALWAYS DO BETTER
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ServeYouth



// WEBPACK FOOTER //
// ./src/containers/AboutPage/ConverseValues/ServeYouth.js